import axiosInstance from './api';

function compactParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );
}

const supportService = {
  getSummary: async ({ developer = false } = {}) => {
    const path = developer ? '/support/developer/summary' : '/support/summary';
    const response = await axiosInstance.get(path);
    return response.data;
  },

  listRequests: async (params = {}) => {
    const response = await axiosInstance.get('/support/requests', { params: compactParams(params) });
    return response.data;
  },

  createRequest: async (payload) => {
    const response = await axiosInstance.post('/support/requests', payload);
    return response.data;
  },

  getRequest: async (requestId) => {
    const response = await axiosInstance.get(`/support/requests/${requestId}`);
    return response.data;
  },

  reply: async (requestId, payload) => {
    const response = await axiosInstance.post(`/support/requests/${requestId}/messages`, payload);
    return response.data;
  },

  markRead: async (requestId) => {
    const response = await axiosInstance.post(`/support/requests/${requestId}/read`);
    return response.data;
  },

  dismiss: async (requestId) => {
    const response = await axiosInstance.post(`/support/requests/${requestId}/dismiss`);
    return response.data;
  },

  updateCustomerStatus: async (requestId, action) => {
    const response = await axiosInstance.patch(`/support/requests/${requestId}/status`, { action });
    return response.data;
  },

  listDeveloperRequests: async (params = {}) => {
    const response = await axiosInstance.get('/support/developer/requests', { params: compactParams(params) });
    return response.data;
  },

  createDeveloperRequest: async (payload) => {
    const response = await axiosInstance.post('/support/developer/requests', payload);
    return response.data;
  },

  getDeveloperRequest: async (requestId) => {
    const response = await axiosInstance.get(`/support/developer/requests/${requestId}`);
    return response.data;
  },

  developerReply: async (requestId, payload) => {
    const response = await axiosInstance.post(`/support/developer/requests/${requestId}/messages`, payload);
    return response.data;
  },

  updateDeveloperRequest: async (requestId, updates) => {
    const response = await axiosInstance.patch(`/support/developer/requests/${requestId}`, updates);
    return response.data;
  },

  getDeveloperRecipients: async (orgId) => {
    const response = await axiosInstance.get('/support/developer/recipients', { params: { orgId } });
    return response.data.users || [];
  },

  getDeveloperAgents: async () => {
    const response = await axiosInstance.get('/support/developer/agents');
    return response.data.agents || [];
  }
};

export { compactParams };
export default supportService;
